'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FETCH_THREAD_HISTORY = undefined;

var _createAsyncActionTypes = require('conversations-async-data/async-action/createAsyncActionTypes');

var FETCH_THREAD_HISTORY = exports.FETCH_THREAD_HISTORY = (0, _createAsyncActionTypes.createAsyncActionTypes)('FETCH_THREAD_HISTORY');